let moduleName = 'loading';

class LoadingDirective {
    constructor() {
        this.restrict = 'AEC';
        this.template = '<div class="spinner"> <div class="bounce1"></div> <div class="bounce2"></div> <div class="bounce3"></div> </div>';
        this.scope = {};
    }

    static directiveFactory(){
        return new LoadingDirective();
    }
}

LoadingDirective.directiveFactory.$inject = [];

angular.module(moduleName, [])
    .directive('loadingDirective', LoadingDirective.directiveFactory);


export default moduleName;



// WEBPACK FOOTER //
// ./src/app/directives/loading/loadingDirective.js